/**
 * Tuyen dung
 */

export default function Recruitments() {
    const selectors = {
        'wrapper' : '.js-recruitments-filter-box',
        'form' : '.js-filter-recruitment-form',
        'result' : '.js-recruitments-results',
        'pagination' : '.js-recruitments-pagination',
        'positionToggle' : '.js-open-position-box',
    };

    this.init = () => {
        let $form = jQuery(selectors.form);
        if (!$form.length) return;
        this.handleForm();
        this.display(jQuery(selectors.form));
        this.handlePagination();
    }

    this.template = () => {
        let compiled = null;
        compiled = _.template('<div class="recruitment relative flex flex-col mt-5 pb-4 border-b border-b-gray-200"> ' +
            '<a href="<%= url %>" class="text-primary md:text-lg text-base leading-tight font-medium mb-10px"><%= name %></a> ' +
            '<span class="text-black md:text-base text-sm leading-tight mb-2"><%= locations %></span> ' +
            '<ul class="meta flex gap-5"> ' +
            '<li class="relative text-gray-text md:text-base text-sm leading-tight"><%= type %></li> ' +
            '<li class="relative text-gray-text md:text-base text-sm leading-tight"><%= salary %></li> ' +
            '</ul> ' +
            '<div class="md:absolute md:top-0 md:right-0 md:mt-0 mt-5 "><a href="<%= url %>" class="inline-block border border-primary rounded-40px text-xs leading-tight font-medium px-5 md:py-13px py-7px text-primary hover:bg-button-hover transition-colors duration-400">Ứng tuyển</a></div>' +
            '</div>');

        return compiled;
    }

    this.getRecruitments = async (search, location, positions, paged = 1) => {
        return jQuery.ajax({
            type : "GET",
            dataType : "JSON",
            url : theme_object.endpoint_url + 'recruitments',
            data : {
                q: search,
                location: location,
                positions: positions,
                paged: paged,
            },
            context: this
        })
    }

    this.display = async ($form) => {
        let search = $form.find('[name="search"]').val();
        let location = $form.find('[name="location"]:checked').val();
        let positions = $form.find('[name="position[]"]:checked');
        let position_arr = new Array();
        if (positions.length) {
            positions.each(function(){
                position_arr.push(jQuery(this).val())
            })
        }
        let paged = parseInt($form.find('[name="paged"]').val());
        let wrapper = jQuery(selectors.wrapper);
        wrapper.find('.js-overlay').css({"display":"flex"});
        await this.getRecruitments(search, location, position_arr.join(','), paged).then( (res) => {
            let resultsDom = jQuery(selectors.wrapper).find(selectors.result);
            if (res.data && res.data.length) {
                let itemTemplate = this.template();
                resultsDom.empty();
                for(let i in res.data) {
                    let item_data = res.data[i];
                    item_data.locations = item_data.location.map(function(item){
                        return item.name
                    }).join(',')
                    resultsDom.append(itemTemplate(item_data));
                }
            } else {
                resultsDom.html(res.message)
            }

            if (res.meta) {
                $form.find('[name="paged"]').val(res.meta.current_page)
                $form.find('[name="total_pages"]').val(res.meta.total_pages)
                jQuery(selectors.pagination).html(this.pagination(res.meta.current_page, res.meta.total_pages))
            }

            wrapper.find('.js-overlay').hide();
        })
    }

    this.handlePagination = () => {
        jQuery(selectors.pagination).on('click', 'a[data-page]', (e) => {
            e.preventDefault();
            let $this = jQuery(e.currentTarget);
            let $form = jQuery(selectors.form);
            let paged = $this.attr('data-page');
            $form.find('[name="paged"]').val(parseInt(paged))
            this.display($form);
        })
    }

    this.handleForm = async () => {
        jQuery(selectors.form).on('submit', async (e) => {
            e.preventDefault();

            let $this = jQuery(e.target);
            $this.find('[name="paged"]').val(1)
            this.display($this);

            return false;
        })

        jQuery(selectors.form).on('change', '[name="location"], [name="position[]"]', async (e) => {
            e.preventDefault();
            let $this = jQuery(e.target).closest(selectors.form);
            $this.find('[name="paged"]').val(1)
            this.display($this);
        })

        jQuery(selectors.form).on('click', selectors.positionToggle, (e) => {
            e.preventDefault();
            if (jQuery(window).width() < 769) {
                jQuery(e.target).next('ul').slideToggle()
            }
        })
    }

    this.pagination = (currentPage, totalPages) => {
        if (totalPages == 1) return '';

        let paginationHTML = '';
        let display;
        let next = '<svg fill=none height=14 viewBox="0 0 8 14"width=8 xmlns=http://www.w3.org/2000/svg><path d="M1.01341 1L7 7L1.01341 13"stroke=#4D5761 stroke-linecap=round /></svg>'
        let prev = '<svg fill=none height=14 viewBox="0 0 8 14"width=8 xmlns=http://www.w3.org/2000/svg><path d="M6.98659 1L1 7L6.98659 13"stroke=#4D5761 stroke-linecap=round /></svg>'
        // Previous button
        if (currentPage > 1) {
            paginationHTML += `<a href="#" data-page="${currentPage - 1}" class="prev md:mr-10">${prev}</a>`;
        }

        // First page
        if (currentPage > 2) {
            paginationHTML += `<a href="#" data-page="1" class="text-lg text-gray-600 leading-tight font-light">01</a>`;
        }

        // Ellipsis before current page range
        if (currentPage > 3) {
            paginationHTML += `<span class="dots text-lg text-gray-600 leading-tight font-light">...</span>`;
        }

        // Page numbers around the current page
        let startPage = Math.max(1, currentPage - 1);
        let endPage = Math.min(totalPages, currentPage + 1);

        for (let i = startPage; i <= endPage; i++) {
            display = i;
            if(i<10 && i > 0) {
                display = '0'+i;
            }
            if (i === currentPage) {
                paginationHTML += `<span class="active text-lg text-primary leading-tight font-medium">${display}</span>`;
            } else {
                paginationHTML += `<a href="#" data-page="${i}" class="text-lg text-gray-600 leading-tight font-light">${display}</a>`;
            }
        }

        // Ellipsis after current page range
        if (currentPage < totalPages - 2) {
            paginationHTML += `<span class="dots text-lg text-gray-600 leading-tight font-light">...</span>`;
        }

        // Last page
        if (currentPage < totalPages - 1) {
            display = totalPages;
            if(totalPages < 10 && totalPages > 0) {
                display = '0'+totalPages;
            }
            paginationHTML += `<a href="#" data-page="${totalPages}" class="text-lg text-gray-600 leading-tight font-light">${display}</a>`;
        }

        // Next button
        if (currentPage < totalPages) {
            paginationHTML += `<a href="#" data-page="${currentPage + 1}" class="next md:ml-10">${next}</a>`;
        }

        return paginationHTML;
    }

}
